import instance from 'api';
import { AxiosRequestConfig } from 'axios';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel, IPositionModel } from 'interfaces';
import { IFixedItemShort, IFormulaVariable, IModel, IModelItem, IPriceListServices } from './interfaces';

export const getModelList = (data: IDynamicTableParams) => {
  return instance()
    .post<IModel[]>('/calculatorTariff/model/list', data)
    .then((response) => response.data);
};

export const getModelAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/calculatorTariff/model/availableColumns')
    .then((response) => response.data);
};

export const getModelAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/calculatorTariff/model/availableGroupColumns')
    .then((response) => response.data);
};

export const loadModel = (modelId: number) => {
  return instance()
    .get<IModel>(`/calculatorTariff/model/load/${modelId}`)
    .then((response) => response.data);
};

export const createModel = (model: Pick<IModel, 'modelName' | 'description'>) => {
  return instance()
    .post<IModel>('/calculatorTariff/model/create', model)
    .then((response) => response.data);
};

export const updateModel = (model: IModel) => {
  return instance()
    .post<IModel>(`/calculatorTariff/model/${model.modelId}/update`, model)
    .then((response) => response.data);
};

export const archiveModel = (modelId: number) => {
  return instance()
    .post(`/calculatorTariff/model/${modelId}/archive`)
    .then((response) => response.data);
};

export const activateModel = (modelId: number) => {
  return instance()
    .post(`/calculatorTariff/model/${modelId}/activate`)
    .then((response) => response.data);
};

export const updateModelItem = (itemId: number, item: IModelItem) => {
  return instance()
    .post<IModelItem>(`/calculatorTariff/item/${itemId}/update`, item)
    .then((response) => response.data);
};

export const createModelItem = (item: IModelItem) => {
  return instance()
    .post<IModelItem>('/calculatorTariff/item/create', item)
    .then((response) => response.data);
};

export const deleteModelItem = (itemId: number) => {
  return instance()
    .post(`/calculatorTariff/item/${itemId}/delete`)
    .then((response) => response.data);
};

// Dictionary search for model items
export const searchPriceListServices = (config?: AxiosRequestConfig) => {
  return instance()
    .get<IPriceListServices[]>('/calculatorTariff/priceListServices/search', config)
    .then((response) => response.data);
};

export const getPositions = (config?: AxiosRequestConfig) => {
  return instance()
    .post<IPositionModel[]>('/dictionary/positions', {}, config)
    .then((response) => response.data);
};

export const reorderItems = (data: { modelId: number; parentId: number | null; itemIds: number[] }) => {
  return instance()
    .post('/calculatorTariff/item/reorder', data)
    .then((response) => response.data);
};

export const validateFormula = (formula: string) => {
  return instance()
    .post<{ valid: boolean; message?: string; error?: string }>('/calculatorTariff/item/validateFormula', { formula })
    .then((response) => response.data);
};

export const searchFixedItems = (config?: AxiosRequestConfig) => {
  return instance()
    .get<IFixedItemShort[]>('/calculatorTariff/fixedItem/search', config)
    .then((response) => response.data);
};

export const getAllowedVariables = () => {
  return instance()
    .get<IFormulaVariable[]>('/calculatorTariff/item/allowedVariables')
    .then((response) => response.data);
};
